<span *ngIf="badge > 0" class="pkt-btn-badge">{{ badge }}</span>
<ng-container [ngSwitch]="variant">

  <!-- flat -->
  <button *ngSwitchCase="'flat'"
    mat-flat-button
    [type]="type"
    [color]="color"
    [disabled]="disabled || loading"
    [matTooltip]="tooltip"
    class="pkt-btn"
    [class.pkt-btn--sm]="size === 'sm'"
    [class.pkt-btn--lg]="size === 'lg'"
    [class.pkt-btn--full]="fullWidth"
    [ngClass]="themeClass"
    (click)="onClick($event)">
    <mat-progress-spinner *ngIf="loading" class="pkt-btn-spinner" mode="indeterminate" diameter="14" strokeWidth="2"></mat-progress-spinner>
    <span *ngIf="!loading && icon && iconPosition === 'prefix'" class="material-symbols-outlined pkt-btn-icon">{{ icon }}</span>
    <span *ngIf="label">{{ label }}</span>
    <span *ngIf="!loading && icon && iconPosition === 'suffix'" class="material-symbols-outlined pkt-btn-icon">{{ icon }}</span>
  </button>

  <!-- raised — same as flat but with Material elevation -->
  <button *ngSwitchCase="'raised'"
    mat-raised-button
    [type]="type"
    [color]="color"
    [disabled]="disabled || loading"
    [matTooltip]="tooltip"
    class="pkt-btn pkt-btn--raised"
    [class.pkt-btn--sm]="size === 'sm'"
    [class.pkt-btn--lg]="size === 'lg'"
    [class.pkt-btn--full]="fullWidth"
    [ngClass]="themeClass"
    (click)="onClick($event)">
    <mat-progress-spinner *ngIf="loading" class="pkt-btn-spinner" mode="indeterminate" diameter="14" strokeWidth="2"></mat-progress-spinner>
    <span *ngIf="!loading && icon && iconPosition === 'prefix'" class="material-symbols-outlined pkt-btn-icon">{{ icon }}</span>
    <span *ngIf="label">{{ label }}</span>
    <span *ngIf="!loading && icon && iconPosition === 'suffix'" class="material-symbols-outlined pkt-btn-icon">{{ icon }}</span>
  </button>

  <!-- stroked -->
  <button *ngSwitchCase="'stroked'"
    mat-stroked-button
    [type]="type"
    [color]="color"
    [disabled]="disabled || loading"
    [matTooltip]="tooltip"
    class="pkt-btn"
    [class.pkt-btn--sm]="size === 'sm'"
    [class.pkt-btn--lg]="size === 'lg'"
    [class.pkt-btn--full]="fullWidth"
    [ngClass]="themeClass"
    (click)="onClick($event)">
    <mat-progress-spinner *ngIf="loading" class="pkt-btn-spinner" mode="indeterminate" diameter="14" strokeWidth="2"></mat-progress-spinner>
    <span *ngIf="!loading && icon && iconPosition === 'prefix'" class="material-symbols-outlined pkt-btn-icon">{{ icon }}</span>
    <span *ngIf="label">{{ label }}</span>
    <span *ngIf="!loading && icon && iconPosition === 'suffix'" class="material-symbols-outlined pkt-btn-icon">{{ icon }}</span>
  </button>

  <!-- icon only — always shows tooltip, falls back to label -->
  <button *ngSwitchCase="'icon'"
    mat-icon-button
    [type]="type"
    [disabled]="disabled || loading"
    [matTooltip]="effectiveTooltip"
    [class.pkt-icon-btn--sm]="size === 'sm'"
    [class.pkt-icon-btn--lg]="size === 'lg'"
    [class.pkt-icon-btn--bordered]="bordered"
    [ngClass]="themeClass"
    (click)="onClick($event)">
    <mat-progress-spinner *ngIf="loading" class="pkt-btn-spinner" mode="indeterminate" [diameter]="size === 'sm' ? 12 : 16" strokeWidth="2"></mat-progress-spinner>
    <span *ngIf="!loading" class="material-symbols-outlined pkt-btn-icon" [class.pkt-btn-icon--spin]="spinIcon">{{ icon }}</span>
  </button>

  <!-- text (default) -->
  <button *ngSwitchDefault
    mat-button
    [type]="type"
    [color]="color"
    [disabled]="disabled || loading"
    [matTooltip]="tooltip"
    class="pkt-btn"
    [class.pkt-btn--sm]="size === 'sm'"
    [class.pkt-btn--lg]="size === 'lg'"
    [class.pkt-btn--full]="fullWidth"
    [ngClass]="themeClass"
    (click)="onClick($event)">
    <mat-progress-spinner *ngIf="loading" class="pkt-btn-spinner" mode="indeterminate" diameter="14" strokeWidth="2"></mat-progress-spinner>
    <span *ngIf="!loading && icon && iconPosition === 'prefix'" class="material-symbols-outlined pkt-btn-icon">{{ icon }}</span>
    <span *ngIf="label">{{ label }}</span>
    <span *ngIf="!loading && icon && iconPosition === 'suffix'" class="material-symbols-outlined pkt-btn-icon">{{ icon }}</span>
  </button>

</ng-container>
